export default function EvaluareNationalaPage() {

  const documente = [
    { titlu: "METODOLOGIA DE ORGANIZARE SI DESFASURARE A EVALUARII NATIONALE", fisier: "/educatie/evaluareNationala2026/2010-08-31-4801-omects-met-org-&-desf-en08.pdf"},
    { titlu: "PROCEDURĂ cu privire la asigurarea condițiilor de egalizare a șanselore", fisier: "/educatie/evaluareNationala2026/2025-10-27-32051-mec-proc-asig-cond-egalizare-sanse-en08-&-bac-fara-semn.pdf" },
  ];

  return (
    <div className="bg-gray-50 min-h-screen">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <div className="mb-12">
          <h2 className="text-3xl font-bold mb-6">
            Evaluare Națională
          </h2>

          <ul className="space-y-3">
            {documente.map((doc, index) => (
              <li key={index}>
                <a
                  href={doc.fisier}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  {doc.titlu}
                </a>
              </li>
            ))}
          </ul>

        </div>

      </main>
    </div>
  );
}